<script setup lang="ts">
/**
 * 客服微信二维码(**人工客服**)—— 全应用统一的占位组件。
 *
 * 功能开通 / 加量 / 升级走人工客服(扫码加客服微信),区别于智能客服(iris,只答程序
 * 使用问题)。用于:UpgradeModal(能力升级)/ 系统设置·套餐与用量。
 *
 * TODO: 拿到真实二维码后,把图片放 `src/assets/support-qr.png`,启用下方 <img>、
 * 删占位块 —— **全应用只改这一处**。
 */
withDefaults(defineProps<{ size?: number }>(), { size: 160 })
</script>

<template>
  <div class="sqr">
    <!-- 真图到位后启用(删下面 .sqr-ph 占位):
    <img
      src="@/assets/support-qr.png"
      class="sqr-img"
      :style="{ width: size + 'px', height: size + 'px' }"
      alt="客服微信二维码"
    />
    -->
    <div class="sqr-ph" :style="{ width: size + 'px', height: size + 'px' }">
      <i class="ti ti-qrcode" aria-hidden="true"></i>
      <span>客服微信二维码<br />(待放入)</span>
    </div>
  </div>
</template>

<style scoped>
.sqr {
  display: flex;
  justify-content: center;
}
.sqr-img {
  border-radius: var(--border-radius-md);
  object-fit: contain;
}
.sqr-ph {
  border: 1px dashed var(--color-border-secondary);
  border-radius: var(--border-radius-md);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--color-text-tertiary);
  font-size: var(--fs-label);
  line-height: 1.4;
  text-align: center;
}
.sqr-ph i {
  font-size: 40px;
}
</style>
